import axios from 'axios';
import { API_PATH } from '../constants/ApiPath'


export async function getData(url) {
    let headerInfo = null
    if(localStorage.getItem("token")){
      headerInfo = {
          'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
      }
    }
    else{
      headerInfo = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
      }
    }
    try {
       let res = await axios({
            url: API_PATH.concat(url),
            method: 'get',
            // timeout: 8000,
            headers: headerInfo

        })
        if(res.status === 200){
            // test for status you want, etc
            // console.log(res.status)
        }
        // Don't forget to return something
        return res
    }
    catch (err) {
        // console.error(err);
    }
}
export async function getFile(url) {
    let headerInfo = null
    if(localStorage.getItem("token")){
      headerInfo = {
          'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
      }
    }
    else{
      headerInfo = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
      }
    }
    try {
       let res = await axios({
            url: API_PATH.concat(url),
            method: 'GET',
            responseType: 'blob',
            headers: headerInfo

        })
        if(res.status === 200){
            console.log(res,'rrty3')
            // test for status you want, etc
        }
        console.log(res,'rrty2')
        // Don't forget to return something
        return res
    }
    catch ({response}) {
        console.log(response,'rrty')
        return response
        // console.error(err);
    }
}

export async function createData(url, data) {
    const headers = {
        'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,
    }
    try {
       let res =axios.post(API_PATH.concat(url), data, {headers} )
    //    console.error(res,'dddd');
       return res
    }
    catch (err) {
        // console.error(err);
    }
}
export async function createDataNew(url, data, options = {}) {
  const headers = {
    Authorization: `Token ${
      localStorage.getItem("token") ? localStorage.getItem("token") : ""
    }`,
    ...options.headers, // allow custom headers like multipart/form-data
  };

  try {
    const res = await axios.post(API_PATH.concat(url), data, {
      headers,
      responseType: options.responseType || "json", // default JSON, can be 'blob'
    });
    return res;
  } catch (err) {
    // propagate error to caller
    if (err.response && err.response.data) {
      return Promise.reject(err);
    }
    console.error("API Error:", err);
    throw err;
  }
}
export async function createDataUnAuth(url, data) {
    const headers = {
        // 'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,
    }
    try {
       let res =axios.post(API_PATH.concat(url), data, {headers} )
       return res
    }
    catch (err) {
        // console.error(err);
    }
}


export async function createUser(url, data) {

    try {
       let res =axios.post(API_PATH.concat(url), data)
       return res
    }
    catch (err) {
        // console.error(err);
    }
}


export async function fetchUser() {
  if(!localStorage.getItem('token')){
    return 0
  }
  try {
     let res = await axios({
          url: API_PATH.concat('/partner/login-user-info/'),
          method: 'get',
          // timeout: 8000,
          headers: {
              'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
          }
      })
      if(res.status == 200){
        //   console.log(res.status)
      }
      return res
  }
  catch (err) {
      console.log('status--->>', err.response.status)
       if(err.response.status === 401){
         localStorage.clear()
         window.location="/portals"
       }
  }
}



export async function fetchBank(bank) {
  try {
     let res = await axios({
          url: "https://ifsc.razorpay.com/"+bank.trim(),
          method: 'get',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',

          }
      })
      if(res.status == 200){
        //   console.log(res.status)
      }
      return res
  }
  catch (err) {
    //   console.error(err);
  }
}


export async function patchData(url, data) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token') ? localStorage.getItem('token') : ''}`
    }
    try {
       let res =axios.patch(API_PATH.concat(url), data ,{ headers: headers})
       return res
    }
    catch (err) {
        // console.error(err);
    }
}

export async function patchDataUnAuth(url, data) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
    try {
       let res =axios.patch(API_PATH.concat(url), data ,{ headers: headers})
       return res
    }
    catch (err) {
        // console.error(err);
    }
}

export async function deleteData(url) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')?localStorage.getItem('token'):''}`,

    }
    try {
       let res = axios.delete(API_PATH.concat(url),{ headers: headers})
       return res
    }
    catch (err) {
        // console.error(err);
    }
}
